import {ReactNode} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {MODAL_CONFIRM_LAYOUT_CONTENT} from "../constants/modal_confirm_layout_content";

interface IProps {
    cancelButtonText?: string;
    children?: ReactNode;
    okButtonText?: string;
    onCancel?: () => void;
    onConfirmation?: () => void;
    title: string;
}

export const ModalConfirmLayout = (props: IProps) => {
    const {cancelButtonText, children, okButtonText, onCancel, onConfirmation, title} = props;

    return (
        <div className={innerWrapStyle}>
            <Text mb={1.5} variant="headline_3">
                {title}
            </Text>

            {children && (
                <Text as="div" variant="body_copy_1">
                    {children}
                </Text>
            )}

            <div className={buttonWrapperStyle}>
                <Button onClick={onConfirmation} variant="filled_primary">
                    {okButtonText ?? MODAL_CONFIRM_LAYOUT_CONTENT.OK_BUTTON}
                </Button>

                <Button onClick={onCancel} variant="none_secondary">
                    {cancelButtonText ?? MODAL_CONFIRM_LAYOUT_CONTENT.CANCEL_BUTTON}
                </Button>
            </div>
        </div>
    );
};

const buttonWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 2,
    mt: 3
});

const innerWrapStyle = css({
    position: "relative",
    width: "100%",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    px: 4,
    pt: 6,
    pb: 4,

    md: {
        height: "auto",
        px: 4,
        pt: 4,
        pb: 4,
        borderRadius: "1"
    }
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {MODAL_CONFIRM_LAYOUT_CONTENT} from "../constants/modal_confirm_layout_content";

interface IProps {
    cancelButtonText?: string;
    children?: ReactNode;
    okButtonText?: string;
    onCancel?: () => void;
    onConfirmation?: () => void;
    title: string;
}

export const ModalConfirmLayout = (props: IProps) => {
    const {cancelButtonText, children, okButtonText, onCancel, onConfirmation, title} = props;

    return (
        <div className={innerWrapStyle}>
            <Text mb={1.5} variant="headline_3">
                {title}
            </Text>

            {children && (
                <Text as="div" variant="body_copy_1">
                    {children}
                </Text>
            )}

            <div className={buttonWrapperStyle}>
                <Button onClick={onConfirmation} variant="filled_primary">
                    {okButtonText ?? MODAL_CONFIRM_LAYOUT_CONTENT.OK_BUTTON}
                </Button>

                <Button onClick={onCancel} variant="none_secondary">
                    {cancelButtonText ?? MODAL_CONFIRM_LAYOUT_CONTENT.CANCEL_BUTTON}
                </Button>
            </div>
        </div>
    );
};

const buttonWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 2,
    mt: 3
});

const innerWrapStyle = css({
    position: "relative",
    width: "100%",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    px: 4,
    pt: 6,
    pb: 4,

    md: {
        height: "auto",
        px: 4,
        pt: 4,
        pb: 4,
        borderRadius: "1"
    }
});
